export default "__VITE_ASSET__5bc2e277__"